import { useEffect, useRef, useState } from "react";
import { useTranslate } from "@refinedev/core";

export const useStepTimer = (isActive: boolean, isDone: boolean) => {
  const t = useTranslate();
  const [elapsed, setElapsed] = useState(0);
  const intervalIdRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const startTimeRef = useRef(0);

  useEffect(() => {
    if (isActive && !isDone) {
      startTimeRef.current = Date.now();
      const update = () =>
        setElapsed(Math.floor((Date.now() - startTimeRef.current) / 1000));
      intervalIdRef.current = setInterval(update, 1000);

      const onVisible = () => {
        if (document.visibilityState === "visible") update();
      };
      document.addEventListener("visibilitychange", onVisible);

      return () => {
        if (intervalIdRef.current) clearInterval(intervalIdRef.current);
        document.removeEventListener("visibilitychange", onVisible);
      };
    }
    return () => {
      if (intervalIdRef.current) clearInterval(intervalIdRef.current);
    };
  }, [isActive, isDone]);

  return isDone
    ? t("media.autopilot.timer.thoughtFor", { seconds: elapsed })
    : t("media.autopilot.timer.elapsed", { seconds: elapsed });
};
